module.exports = __webpack_public_path__ + "img/item_morningglow_ida_2024@2x.9f71a6a.jpg";